import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import {
    fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess
} from "../common/submitForm";
import { logout, onForbidden } from '../account/login';

//- Actions
export const fetchGetUserSettingsFailed = createAction('FETCH_GET_USER_SETTINGS_FAILED');
export const fetchGetUserSettingsSuccess = createAction('FETCH_GET_USER_SETTINGS_SUCCESS');
export const fetchGetUserSettings = createAction(
    'FETCH_GET_USER_SETTINGS',
    () => Api.getUserSettings(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetUserSettingsSuccess,
        onFail: fetchGetUserSettingsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onUpdateUserSettingsSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetUserSettings());
};

export const fetchUpdateUserSettings = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateUserSettings(data));
};
export const onUpdateUserSettings = createAction(
    'FETCH_UPDATE_USER_SETTINGS',
    (data) => Api.updateUserSettings(data),
    () => ({
        apiCall: true,
        onSuccess: onUpdateUserSettingsSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
    
export const clearUserSettings = createAction('CLEAR_USER_SETTINGS');

//- State
const initialState = {
    fetching: false,
    data: null
};

//- Reducers
export default handleActions({
    FETCH_GET_USER_SETTINGS: (state) => {
        return {...state, error: null, fetching: true};
    },
    FETCH_GET_USER_SETTINGS_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_USER_SETTINGS_SUCCESS: (state, action) => {
        return {...state, data: action.payload, error: null, fetching: false};
    },
    CLEAR_USER_SETTINGS: (state) => {
        return {...state, data: null};
    }
}, initialState);

//- Selectors
export const getUserSettings = state => state.userSettings;

export const getUserSettingsData = state => getUserSettings(state).data;

export const getUserSettingsLoading = state => getUserSettings(state).fetching;


// WEBPACK FOOTER //
// ./src/reducers/account/userSettings.js